import React from "react";

export default function HeroLiquid({ onClick }) {
  return (
    <section id="hero" className="section-liquid">
      <div className="container-liquid">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "60px",
            alignItems: "center",
            minHeight: "calc(100vh - 80px)",
            padding: "0",
            position: "relative",
          }}
        >
          {/* Floating Glass Elements */}
          <div
            className="liquid-floating-element"
            style={{
              width: "120px",
              height: "120px",
              top: "10%",
              right: "15%",
              animationDelay: "0s",
            }}
          ></div>
          <div
            className="liquid-floating-element"
            style={{
              width: "80px",
              height: "80px",
              top: "60%",
              left: "5%",
              animationDelay: "-2s",
            }}
          ></div>
          <div
            className="liquid-floating-element"
            style={{
              width: "100px",
              height: "100px",
              top: "30%",
              right: "60%",
              animationDelay: "-4s",
            }}
          ></div>
          {/* Left Content */}
          <div style={{ textAlign: "left" }}>
            <span className="subheading-liquid">Welcome to Online Badho</span>
            <h1
              className="heading-liquid"
              style={{
                fontSize: "clamp(2.5rem, 5vw, 4rem)",
                marginTop: "16px",
                marginBottom: "24px",
              }}
            >
              Grow Your Business <br />
              <span
                style={{
                  background: "var(--gradient-ios-blue)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Online
              </span>
            </h1>
            <p
              className="text-liquid"
              style={{
                fontSize: "1.25rem",
                marginBottom: "32px",
                maxWidth: "500px",
              }}
            >
              Unlock the Power of Our Service. Stand out online with our
              expertise in creating stunning digital experiences.
            </p>
            <div
              style={{
                display: "flex",
                gap: "16px",
                flexWrap: "wrap",
              }}
            >
              <button
                className="glass-button glass-button-primary glow"
                onClick={() => onClick("Services")}
                style={{
                  fontSize: "1.1rem",
                  padding: "16px 32px",
                }}
              >
                Get Started
              </button>
              <button
                className="glass-button"
                onClick={() => onClick("Pricing")}
                style={{
                  fontSize: "1.1rem",
                  padding: "16px 32px",
                }}
              >
                View Pricing
              </button>
            </div>
          </div>

          {/* Right Content - Glass Card */}
          <div className="liquid-float">
            <div
              className="glass"
              style={{
                padding: "40px",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Decorative gradient overlay */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background:
                    "linear-gradient(135deg, rgba(0, 122, 255, 0.1) 0%, rgba(88, 86, 214, 0.1) 100%)",
                  borderRadius: "20px",
                }}
              ></div>

              <div style={{ position: "relative", zIndex: 1 }}>
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    background: "var(--gradient-primary)",
                    borderRadius: "20px",
                    margin: "0 auto 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "2rem",
                  }}
                >
                  🚀
                </div>
                <h3
                  className="heading-liquid"
                  style={{
                    fontSize: "1.5rem",
                    marginBottom: "16px",
                  }}
                >
                  Ready to Launch?
                </h3>
                <p
                  className="text-liquid"
                  style={{
                    marginBottom: "24px",
                  }}
                >
                  Join thousands of businesses that trust us with their digital
                  presence.
                </p>
                <button
                  className="glass-button glass-button-secondary"
                  onClick={() => onClick("Contact")}
                >
                  Contact Us Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
